module.exports = __webpack_public_path__ + "static/media/associated_engineering.5351117c.jpg";